import { QueryHookOptions, useQuery } from '@apollo/react-hooks'
import { BLOG_POSTS_BY_SLUG_QUERY } from 'apollo'
import { merge } from 'merge-anything'

const DEFAULTS = {
  variables: {
    query: {
      key: process.env.NEXT_PUBLIC_CONTENT_API_KEY,
      include: 'authors,tags',
    },
  },
}

export const useBlogPostsBySlugQuery = (options: QueryHookOptions<any, any> = {}) =>
  useQuery(BLOG_POSTS_BY_SLUG_QUERY, merge(DEFAULTS, options))
